import React from 'react'

type YoutubeEmbedProps = {
  embedId: string
} & React.HTMLAttributes<HTMLDivElement>

export const YoutubeEmbed = ({ embedId, ...props }: YoutubeEmbedProps) => (
  <div
    {...props}
    className={`overflow-hidden aspect-[1.77] relative ${props.className ?? ''}`}
  >
    <iframe
      src={`https://www.youtube.com/embed/${embedId}`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
      className="absolute top-0 left-0 w-full h-full"
    />
  </div>
)
